module.exports = __webpack_public_path__ + "static/media/top-search-dark-icon.5bd142a6.svg";